// extracted by mini-css-extract-plugin
module.exports = {"content":"VehicleDamageInspectionPointStepContainer_content__1Si4i","search":"VehicleDamageInspectionPointStepContainer_search__eEPWv"};